import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const RestoreIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M2 6.66663H8.66667C10.0812 6.66663 11.4377 7.22853 12.4379 8.22872C13.4381 9.22892 14 10.5855 14 12V13.3333M2 6.66663L6 10.6666M2 6.66663L6 2.66663"
      stroke="#111928"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RestoreIcon;
